import AdminNavigation from './admin-navigation-component';
import AdminNavigationService from './admin-navigation-service';

import './admin-navigation.scss';

const MODULE_NAME = 'App.admin.navigation';
const module = angular
    .module(MODULE_NAME, [
        'app.admin.states',
    ])
    .directive(AdminNavigation.DIRECTIVE_NAME, AdminNavigation)
    .service('adminNavigationService', AdminNavigationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-navigation/admin-navigation-module.js